import clsx from 'clsx';
import { forwardRef, ReactElement } from 'react';
import { ListBox, Popover, PopoverProps, Selection } from 'react-aria-components';
import useDataTestId from '~/hooks/useDataTestId';
import { ListBoxOptionEntry, ListBoxOptionItem } from './ListBoxPopover';
import styles from './ListBoxPopover.module.scss';

interface Props {
  additionalContent?: ReactElement;
  maxHeight?: number;
  options: ListBoxOptionEntry[];
  popoverClassName?: string;
  triggerRef: PopoverProps['triggerRef'];
  isOpen: PopoverProps['isOpen'];
  offset?: PopoverProps['offset'];
  onSelectionChange: (ids: Selection) => void;
  selectedOptions: Selection;
  onOpenChange: (val: boolean) => void;
  listLabel: string;
  dataTestId?: string;
}

const MultiListBoxPopover = forwardRef<HTMLElement, Props>((props, ref) => {
  const dt = useDataTestId(props.dataTestId);
  return (
    <Popover
      triggerRef={props.triggerRef}
      className={clsx(styles.popover, props.popoverClassName)}
      maxHeight={props.maxHeight}
      shouldFlip
      offset={props.offset}
      isOpen={props.isOpen}
      ref={ref}
      onOpenChange={props.onOpenChange}
      shouldCloseOnInteractOutside={(element) => {
        return element.id !== props.triggerRef?.current?.id;
      }}
      isNonModal
      data-testid={dt()}
    >
      <ListBox
        className={styles.listBox}
        autoFocus="first"
        onSelectionChange={props.onSelectionChange}
        selectedKeys={props.selectedOptions}
        selectionMode="multiple"
        aria-label={props.listLabel}
      >
        {props.options.map((option) => (
          <ListBoxOptionItem key={option.id} option={option} />
        ))}
      </ListBox>
      {props.additionalContent}
    </Popover>
  );
});

export default MultiListBoxPopover;
